import axios from "axios";
import { API } from "./api";

// Lightweight, fire-and-forget analytics. Never blocks or breaks the UI.
export function track(name, meta = {}) {
  try {
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    axios.post(`${API}/events`, { name, path, meta }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
}
